import UserDevice from 'services/user-device';

function vibrateDevice(pattern: number | number[]) {
    if (!UserDevice.getInstance()?.isDeviceMobile()) return;

    // NOTE: This does not work in safari
    if (typeof window.navigator.vibrate === 'function') {
        window.navigator.vibrate(pattern);
    }
}

export default vibrateDevice;
